// okta doesn't seem to export constants for EventContext.formName, so we are defining them here
// if in the future, they add those, we can remove these
export var RESET_AUTHENTICATOR_FORM_NAME = "reset-authenticator";
export var ENROLL_PROFILE_FORM_NAME = "enroll-profile";
export var IDENTIFY_FORM_NAME = "identify";
export var CHALLENGE_AUTHENTICATOR_KEY_FORM_NAME = "challenge-authenticator";
export var CHALLENGE_AUTHENTICATOR_OTP_FORM_NAME = "authenticator-verification-data";
export var CHALLENGE_AUTHENTICATOR_SELECTOR_FORM_NAME = "select-authenticator-authenticate";
export var SELECT_AUTHENTICATOR_ENROLL_FORM_NAME = "select-authenticator-enroll";
export var ENROLL_AUTHENTICATOR_FORM_NAME = "enroll-authenticator";
export var EMAIL_OPTIN_CHECKBOX_KEY = "membership.emailOptIn";
export var LOCALE_TEXTBOX_KEY = "userProfile.locale";
// okta error code
export var INVALID_CREDENTIALS_OKTA_ERROR_KEY = "errors.E0000004";
export var ACCT_ALREADY_EXISTS_OKTA_ERROR_KEY = "registration.error.notUniqueWithinOrg";
export var INVALID_PASSCODE_OKTA_ERROR_KEY = "api.authn.error.PASSCODE_INVALID";
export var PASSCODE_ATTEMPTS_OKTA_ERROR_KEY = "oie.tooManyRequests";
export var ACCT_ALREADY_EXISTS_CUSTOM_ERROR_KEY = "custom.account.login.already.exists.error";
export var ACCT_ALREADY_EXISTS_ERROR_LOCATION = "register";
export var INVALID_CREDENTIALS_CUSTOM_ERROR_KEY = "custom.account.login.invalid.credentials.error";
export var INVALID_CREDENTIALS_ERROR_LOCATION = "login";
export var INVALID_PASSCODE_CUSTOM_ERROR_KEY = "account.login.passcode.empty.error";
export var PASSCODE_ATTEMPTS_CUSTOM_ERROR_KEY = "oie.tooManyRequests";
// certain okta error messages needs to be identified so it would be overwritten
// error handling usage (hooks > use-handle-errors.tsx)
export var EMPTY_ERROR_IDENTIFIER = "empty-error-identifier";
export var ERROR_IDENTIFIER = "error-identifier";
export var TERMINAL = "terminal";
export var INVALID_NONCE = "Invalid nonce.";
export var OPERATION_TIMED_OUT_ERROR = "The operation either timed out or was not allowed.";
